<template>
  <v-footer class="white">
    <v-layout row wrap align-center class="ml-4 mr-4">
      <v-flex xs12 sm10 offset-sm1>
        <div :class="ui.textSubheading">
          Besea Enterprise System {{this.appRevCurrent}}.
        </div>
        <div :class="ui.textSubheading">
          &copy; {{this.year}} {{this.companyTitle3}}. All rights reserved.
        </div>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
/* eslint-disable */
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";
import appRevisions from "@/data/globals/mixins/appRevisions.js";
import moment from "moment";
export default {
  mixins: [apptheme, publicGlobals, appRevisions],
  data() {
    return {
      year: "2024",
      currentPagePath: "/legal"
    };
  },
  beforeMount() {
    this.year = moment().format("YYYY");
  }
};
</script>
